import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import { BreadcrumbPage } from "../../shared";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { getRequest, postRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { CommonCss } from "../../services/CommonCss";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import axios from "axios";
import { cookieKeys, getCookie } from "../../services/Cookies";
import {
  FormHelperText,
  Input,
  Radio,
  InputLabel,
  InputBase,
} from "@material-ui/core";

const TextInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);
const DateInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "90px",
    padding: "10px 10px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
const useStyles = makeStyles((theme) => ({
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 1px #e0e0e0",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  },
 
  tableHeight: {
  //  height:  window.innerHeight  ,
    overflowY: "auto",
    boxShadow: "0 0 0 #eee",
    backgroundColor: "transparent",
    paddingRight: "12px"
  },
  textCenter: {
    textAlign: "center",
  },
  tableCellBox: {
    borderTop: "2px solid #ff000000",
    borderBottom: "2px solid #ff000000",
  },
  iframeBox: {
    backgroundColor: "#5f5f5f",
  },
  active: {
    color: "#ff4717",
  },
  
}));
function Row(props) {
  const { name, date, activeRow, row, onOpenBunkerAlerts } = props;
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const commonClasses = CommonCss();
  // ////console.log(window.screen.height);
  return (
    <React.Fragment>
      <TableRow
        onClick={() => {
          onOpenBunkerAlerts(row);
        }}
        className={commonClasses.cursorPointer}
      >
        <TableCell
          className={
            (classes.tableCellBox, activeRow > -1 ? classes.active : "")
          }
        >
          {name}
        </TableCell>
        {/* <TableCell className={classes.tableCellBox}>{date}</TableCell> */}
      </TableRow>
    </React.Fragment>
  );
}

export default function Alerts() {
  const classes = useStyles();
  const BreadcrumbList = [{ name: "Alerts", url: "" }];
  const [bunkerAlerts, setBunkerAlerts] = useState([]);
  const [bunkerAlertsActive, setBunkerAlertsActive] = useState([]);
  const [openBunkerAlerts, setOpenBunkerAlerts] = useState("");
  const dispatch = useDispatch();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    getBunkerAlerts();
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const getBunkerAlerts = () => {
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts`;
    getRequest(url)
      .then((res) => {
        ////console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setBunkerAlerts(res.data);
          loadPdfFile(res.data[0]);
          setBunkerAlertsActive(res.data[0])
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  };

  const onBunkerAlerts = (data) => {
    ////console.log(data);
    setBunkerAlertsActive(data);
    loadPdfFile(data);
  };

  const loadPdfFile = (data) => {
    dispatch({ type: LOADING, payload: true });
    const token = getCookie("token");

    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/file`;
    let filedata = JSON.stringify({ fileName: data });
    let config = {
      method: "post",
      responseType: "blob",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/pdf"
      },
      data: filedata,
    };
    axios(config)
      .then(async function (response) {
        if (response.status == 200) {
          dispatch({ type: LOADING, payload: false });
          const file = new Blob([response.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          setOpenBunkerAlerts(fileURL);
        } else {
          ToastError(response.data.message);
        }
      })
      .catch(function (error) {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  };
  return (
    <Box component="main" mx={3} className={classes.content + " rightbar alert-rightsidebar"}>
      <Box  pt={0} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
      </Box>
      {/* <Box pb={3} className={classes.boxLayout}>
        <Box component="h2" pl={3} m={0} fontWeight="500" pt={3} pb={1}>
          Filters:
        </Box>
        <Grid container>
          <Grid item xs={12} sm={12} md={5}>
            <Box px={3} height={1}>
              <Box display="block">
                <Box display="flex" pb={1}>
                  <Box component="span" mr={2} fontSize="16px">
                    Date
                  </Box>
                  <Box component="span" mr={2}>
                    <DateInput placeholder="From" />
                  </Box>
                  <Box component="span">
                    <DateInput placeholder="To" />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center">
                  <Box
                    mr={1}
                    component="span"
                    borderRadius="10px"
                    px="10px"
                    py="2px"
                    bgcolor="rgb(214 214 214)"
                    fontSize="12px"
                  >
                    Today
                  </Box>
                  <Box
                    mr={1}
                    component="span"
                    borderRadius="10px"
                    px="10px"
                    py="2px"
                    bgcolor="rgb(214 214 214)"
                    fontSize="12px"
                  >
                    This Week
                  </Box>
                  <Box
                    mr={1}
                    component="span"
                    borderRadius="10px"
                    px="10px"
                    py="2px"
                    bgcolor="rgb(214 214 214)"
                    fontSize="12px"
                  >
                    This Month
                  </Box>
                  <Box
                    mr={1}
                    component="span"
                    borderRadius="10px"
                    px="10px"
                    py="2px"
                    bgcolor="rgb(214 214 214)"
                    fontSize="12px"
                  >
                    Custom
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={7} className="alertlocation">
            <Box  pb={2} >
              <Grid container>
                <Grid item xs={12} pb={2} sm={4} md="4">
                  <Box fontSize="16px">Parameter</Box>
                </Grid>
                <Grid item xs={12} sm={8} md={8}>
                  <TextInput placeholder="" />
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid container>
                <Grid item xs={12} sm={4} md={4}>
                  <Box fontSize="16px">PortLocation</Box>
                </Grid>
                <Grid item xs={12} sm={8} md={8}>
                  <TextInput placeholder="" />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box> */}
      <Box pt={3} className="art-min-ht-full">
        <Grid container spacing={3}  className="alertsection">
          <Grid item xs={12} sm={12} md={4}>
            <TableContainer component={Paper} className={classes.boxLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                      <StyledTableCell className="bl-bg">Name</StyledTableCell>
                    {/* <StyledTableCell>Date</StyledTableCell> */}
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
            <Box className={classes.root} p={2} bgcolor="#fff">
              <TableContainer
                component={Paper}
              //  style={{"height":`${window.screen.height-280}px`}}
                className={clsx(classes.tableHeight, " scroll-bar-200")}
              >
                <Table aria-label="collapsible table">
                  <TableBody>
                    {bunkerAlerts.map((row, index) => {
                      ////console.log(row);
                      const activeRow = bunkerAlertsActive.indexOf(row);
                      // const title = row.split("/");
                      if (index < 40) {
                        return (
                          <Row
                            key={"BunkerAlerts" + index}
                            name={row}
                            row={row}
                            activeRow={activeRow}
                            onOpenBunkerAlerts={onBunkerAlerts}
                            date={"2020"}
                          />
                        );
                      }
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={8}  className="alert-pdf">
            <TableContainer component={Paper} className={classes.boxLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell className="bl-bg"  style={{"height":`40px`}}>
                      Bunker Alert  
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  className={clsx(
                    classes.tableHeight,
                    "scroll-bar-200",
                    classes.iframeBox
                  )}
                >
                  <TableRow>
                    <TableCell className={classes.tableCellBox}>
                      <Box >
                        {openBunkerAlerts ? (
                          <iframe 
                            src={`${openBunkerAlerts}#page=1&toolbar=0`}
                            //src={`${openBunkerAlerts}#page=1&toolbar=0&statusbar=0&scrollbar=1&height=100%`}
                            // frameborder="0"
                           // height={window.screen.height-280}
                           width="100%"
                           //  height={window.screen.height+"px"}
                          // style={{"height":`${window.screen.height-280}px`}}
                          style={{"min-height": '100%'}, {"height":`${window.screen.height-90}px`}}
                          ></iframe>
                        ) : (
                          ""
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
